import { render, staticRenderFns } from "./GetAllRepresentatives.vue?vue&type=template&id=cb06d4cc&"
import script from "./GetAllRepresentatives.vue?vue&type=script&lang=js&"
export * from "./GetAllRepresentatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports